module.exports = __webpack_public_path__ + "static/img/31de202e2bf33529c4c98148c2c403f1.0865960.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/31de202e2bf33529c4c98148c2c403f1.png
// module id = cnIQ
// module chunks = 3